import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import AuthHeader from './AuthHeader'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import StyledButton from './inputs/StyledButton';
import BlueTypography from './typography/BlueTypography';


import {
  is_logged_on,
  extract_errors,
  passComp
 } from "../helpers"

import {
  LocalForm,
  Control,
} from 'react-redux-form'

import Errors from './Errors'
import PasswordCreated from './PasswordCreated'

import {
  isRequired
} from "../validators"

import {
  reset_password,
  reset_password_error,
  reset_password_reset
} from '../actions'

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

const mapDispatchToProps = dispatch => {
  return {
    resetPassword: values => dispatch( reset_password(values) ),
    setError: messages => dispatch( reset_password_error(messages) ),
    resetReset: () => dispatch( reset_password_reset() )
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    errors: state.auth.current_user.errors
  };
}

class ConnectedResetPassword extends React.Component {
  constructor() {
    super()
    this.state = {
      passwordConfirmationValid: true,
      passwordConfirmationError: '',
      passwordValid: true,
      passwordError: '',
      redirect: false,
      formValid: false
    }
  }

  componentWillMount() {
    const { reset_password_token } = this.props.match.params
    if ( reset_password_token === undefined || reset_password_token === null || reset_password_token === '' ) {
      this.setState({redirect: true})
    }
  }

  componentWillUnmount() {
    this.props.resetReset()
  }

  handleSubmit(values) {
    const { reset_password_token } = this.props.match.params
    const submitValues = {
      ...values,
      reset_password_token: reset_password_token
    }
    // console.log("submitValues")
    // console.log(submitValues)
    this.props.resetPassword(submitValues)
  }

  handleUpdate(form) {
    let passwordsMatch = true
    const { password, password_confirmation, $form } = form
    const passwordState = (password.pristine || password.valid)

    if (!password_confirmation.pristine && password_confirmation.value !== password.value) {
      passwordsMatch = false
    }

    const passwordConfirmationState = (password_confirmation.pristine || ( password_confirmation.valid && passwordsMatch ) )

    this.props.setError([])

    const formState = $form.valid && passwordsMatch

    this.setState({
      passwordValid: passwordState,
      passwordConfirmationValid: passwordConfirmationState,
      formValid: formState
    })
  }

  componentDidUpdate(prevProps, prevState){
    const { errors } = this.props
    const prevErrors = prevProps.errors

    const passwordErrors = extract_errors(errors, "password")
    const prevPasswordErrors = extract_errors(prevErrors, "password")

    if (passwordErrors && !prevPasswordErrors) {
      this.setState({
        passwordValid: false,
        passwordError: passwordErrors
      })
    }

    const passwordConfirmationErrors = extract_errors(errors, "password_confirmation")
    const prevPasswordConfirmationErrors = extract_errors(prevErrors, "password_confirmation")

    if (passwordConfirmationErrors && !prevPasswordConfirmationErrors) {
      this.setState({
        passwordConfirmationValid: false,
        passwordConfirmationError: passwordConfirmationErrors
      })
    }


  }


  render() {
    if ( is_logged_on() ) {
      return <Redirect to="/" />
    }

    if ( this.state.redirect === true ) {
      return <Redirect to="/" />
    }

    // console.log(this.props.params)

    if ( this.props.auth.resetSuccessful ) {
      return <PasswordCreated />
    }

    const { passwordValid, passwordConfirmationValid } = this.state

    return (
      <MuiThemeProvider theme={theme}>
        <section className="header">

        <AuthHeader />

          <div className="inner bottom-gap">
            <Grid container spacing={0} justify="center">
              <Grid item xs={12} md={4}>
                <Paper className="no-boxshadow">

                  <LocalForm
                    model="createPassword"
                    className="collection-item"
                    initialState={{ password: '', password_confirmation: '' }}
                    onUpdate={(form) => this.handleUpdate(form)}
                    onSubmit = {(values) => this.handleSubmit(values)}
                  >

                    <div>
                      <BlueTypography
                        className="ls-025"
                        variant="display1"
                        align="center"
                      >
                        Password Reset
                      </BlueTypography>

                      <div class="mt-24 mb-16">
                        <BlueTypography
                          className="ls-28 ls-050"
                          variant="subheading"
                          align="center"
                        >
                          Enter a new password for your account.
                        </BlueTypography>
                      </div>

                    </div>

                    <div className="input-ls-015 mb-36">
                      <Control
                        id="createPassword-password"
                        model="createPassword.password"
                        label="New Password"
                        component={passComp}
                        error={!passwordValid}
                        helperText={passwordValid ? '' :
                          this.state.passwordError || "Password must be at least 7 characters long"
                        }
                        validators={{
                          required: (val) => {
                            return isRequired(val, 7)
                          }
                        }}
                      />
                    </div>

                    <div className="input-ls-015 mb-36">
                      <Control
                        id="createPassword-password_confirmation"
                        model="createPassword.password_confirmation"
                        label="Confirm Password"
                        component={passComp}
                        error={!passwordConfirmationValid}
                        helperText={
                          passwordConfirmationValid ? '' :
                            this.state.passwordConfirmationError || "Password and Confirmation do not match"
                        }
                      />
                    </div>

                      <Errors errors={this.props.errors} ignore={["password","password_confirmation"]}/>

                    <div>

                      <StyledButton
                        size="large"
                        type="submit"
                        aria-label="Sumbit"
                        disabled={!this.state.formValid}
                        className="mdc-instalevel-w-100 ls-125"
                      >CHANGE PASSWORD</StyledButton>

                      {/* <div className="forgot-password mdc-instalevel-w-100 ta-left">
                        <Link to="/" className="mdc-button no-t-transform">Sign In</Link>
                      </div> */}
                    </div>


                  </LocalForm>
                </Paper>
              </Grid>
            </Grid>
          </div>
      </section>
      </MuiThemeProvider>
    )
  }
}

const ResetPassword = connect(mapStateToProps, mapDispatchToProps)(ConnectedResetPassword);

export default ResetPassword



// WEBPACK FOOTER //
// ./src/js/components/ResetPassword.js